module.exports = "table.table.table-condensed {\n  margin-bottom: 0; }\n\nspan.text-danger {\n  position: absolute;\n  bottom: -8px !important; }\n"